import { Box } from '@mui/material'
import { CUSTOM_PROVIDERS } from '@/features/mockModel/customProviders'
import ProviderTile from './ProviderTile'
import styles from './customModelDialog.module.scss'

/** The providers as a grid of logo tiles; exactly one is selected. */
export default function ProviderTiles({ value, onChange }) {
  return (
    <Box className={styles.section}>
      <span className={styles.label} id="custom-model-provider-label">
        Provider
      </span>
      <Box className={styles.tiles} role="radiogroup" aria-labelledby="custom-model-provider-label">
        {CUSTOM_PROVIDERS.map((provider) => (
          <ProviderTile
            key={provider.id}
            provider={provider}
            selected={provider.id === value}
            onSelect={() => onChange(provider.id)}
          />
        ))}
      </Box>
    </Box>
  )
}
